/* FilterUsernamesComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./FilterUsernamesRenderer");

/**
 * @class FilterUsernamesComponent
 * @extends EventEmitter
 *
 * @fires FilterUsernamesComponent#Shutdown
 */
class FilterUsernamesComponent extends EventEmitter {
    /**
     * Creates a new instance of FilterUsernamesComponent.
     *
     * @param {Object} syslogEntity - The syslog entity.
     */
    constructor(syslog) {
        super();
        this._syslog = syslog;
        this._filterMode = this._determineFilterMode();
        this._usernames =
            (this._filterMode ? this._syslog.userIncludeList : this._syslog.userExcludeList) || [];
        this._renderer = new Renderer(this);
    }

    _determineFilterMode() {
        const hasIncludeList =
            Array.isArray(this._syslog.userIncludeList) && this._syslog.userIncludeList.length > 0;
        const hasExcludeList =
            Array.isArray(this._syslog.userExcludeList) && this._syslog.userExcludeList.length > 0;

        if (hasIncludeList) {
            return true;
        }
        if (hasExcludeList) {
            return false;
        }
        // Default to allow mode when both lists are empty or null
        return true;
    }

    get renderer() {
        return this.getRenderer();
    }

    get rootElement() {
        return this._renderer && this._renderer.getRootElement();
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    _shutdown() {
        this._triggerShutdown();
        this._unregisterListeners();

        return Promise.all([this._renderer.shutdown()])
            .then(() => {
                this._renderer = null;
                this._shutdownProm = null;
                this._syslog = null;
            })
            .catch((error) => {
                console.log(`${this.constructor.name}: error in shutdown`);
                console.error(error);
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        if (this._shutdownProm === null) {
            return Promise.resolve();
        }
        this._shutdownProm = this._shutdownProm || this._shutdown();
        return this._shutdownProm;
    }

    closePopUp() {
        this.rejectPopUp({userRejected: true});
    }

    resolvePopup(data) {
        this._context.resolve(data);
    }

    rejectPopUp(data) {
        this._context.reject(data);
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    _triggerShutdown() {
        /**
         * @event FilterUsernamesComponent#Shutdown
         */
        this.emit("Shutdown");
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    save() {
        this.resolvePopup();
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = FilterUsernamesComponent;
